module.exports = __webpack_public_path__ + "img/bk_04.6fc1a011.png";